import React from 'react';
import { Link } from 'gatsby';
import footerTopDots from './footer-top-dots.svg';

import {
  Wrapper,
  Line,
  LineWrapper,
  Menu,
  Body,
  MenusWrapper,
  BrandWrapper,
} from './FooterStyles';
import Logo from '../Logo';
import Container from '../Container';
import SocialBranding from '../SocialMedia/SocialBranding';

const menus = [
  {
    name: 'Mobile App',
    links: [
      { name: 'iOS', url: '/' },
      { name: 'Android', url: '/' },
    ],
  },
  {
    name: 'Discover',
    links: [
      { name: 'Product', url: '/' },
      { name: 'Pricing', url: '/pricing' },
      { name: 'With Slack', url: '/' },
      { name: 'Extensions', url: '/extensions' },
    ],
  },
  {
    name: 'Resources',
    links: [
      { name: 'Blog', url: '/blog' },
      { name: 'Help Center', url: '/help' },
      { name: 'API Documentation', url: '/' },
      { name: 'System Status', url: '/' },
      { name: 'Terms and conditions', url: '/terms-of-service' },
      { name: 'Privacy Policy', url: '/privacy-policy' },
    ],
  },
];

const Footer = () => (
  <Wrapper>
    <img className="footer-top" src={footerTopDots} alt="footer-top-dots" />
    <Container>
      <Body>
        <BrandWrapper>
          <Link to="/">
            <Logo size="3.125rem" />
          </Link>
        </BrandWrapper>

        <MenusWrapper>
          {menus.map(menu => (
            <Menu key={menu.name}>
              <h3>{menu.name}</h3>
              <ul>
                {menu.links.map(({ name, url }) => (
                  <li key={name}>
                    <Link to={url}>{name}</Link>
                  </li>
                ))}
              </ul>
            </Menu>
          ))}
        </MenusWrapper>
      </Body>
    </Container>
    <LineWrapper>
      <Container>
        <Line>
          <div>
            {`Workast, Inc. All rights reserved ${new Date().getFullYear()}`}
          </div>
          <SocialBranding list={['youtube', 'twitter', 'linkedIn']} />
        </Line>
      </Container>
    </LineWrapper>
  </Wrapper>
);

export default Footer;
